import React from "react"
import ChooseHierarchyChip from "./ChooseHierarchyChip"
import { IHierarchyItem, IJobDocument } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import JobsChip from "../../job/JobsChip"
import autobind from "class-autobind"
import * as api from "../../../api"
interface IProps {
    readonly?: boolean
    // cannot change only hierarchy
    readonlyHierarchy?: boolean
    // cannot change only job
    readonlyJob?: boolean
    hideJob?: boolean
    hierarchyChipLabel: string
    jobChipLabel: string
    hierarchyItemId: string
    jobId: string
    errorHierarchyChipText?: string
    errorJobText?: string
    hieararchyChipMaxWidth?: number
    jobChipMaxWidth?: number
    handleSelectHierarchyJob(hierarchyItemId: string, job: IJobDocument): void
    //if getCustomNoAccessErrorStr is exist, don't need getAccessRight
    getAccessRight?(selectedHierarchy: IHierarchyItem): boolean
    getCustomNoAccessErrorStr?(selectedHierarchy: IHierarchyItem): string

    //if Clock device's hierarchy removed, we should open with global filter hierarchy.
    openWithGlobalFilerWhenSelectedHierarchyIsInvalid?: boolean
}
interface IState {
    hierarchyItemId: string
    job: IJobDocument
}

export default class ChooseHierarchyJobChip extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            hierarchyItemId: props.hierarchyItemId,
            job: null
        }
        autobind(this)
    }

    componentDidMount() {
        this.getJob(this.props)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.state.hierarchyItemId !== nextProps.hierarchyItemId &&
            this.setState({ hierarchyItemId: nextProps.hierarchyItemId })
        const stateJobId = this.state.job ? this.state.job.Id : null
        if (stateJobId !== nextProps.jobId) {
            this.getJob(nextProps)
        }
    }

    getJob(props: IProps) {
        props.jobId ?
            props.jobId === AccountStore.DiffJobId ?
                this.setState({ job: AccountStore.DiffJob }) :
                api.getJob(props.jobId).then(res =>
                    this.setState({ job: res.data })
                ) :
            this.setState({ job: null })
    }

    handleSelectHierarchyJob(hierarchyItemId: string, job: IJobDocument) {
        this.setState({ hierarchyItemId, job }, () =>
            this.props.handleSelectHierarchyJob(hierarchyItemId, job)
        )
    }

    render() {
        return (
            <div style={{ display: "flex" }}>
                <div style={{ flex: 1, display: "flex" }}>
                    <ChooseHierarchyChip
                        chipMaxWidth={this.props.hieararchyChipMaxWidth}
                        readonly={this.props.readonly || this.props.readonlyHierarchy}
                        chipLabel={this.props.hierarchyChipLabel}
                        hierarchyItemId={this.state.hierarchyItemId}
                        errorChipText={this.props.errorHierarchyChipText}
                        handleSelectHierarchy={hierarchyItemId => this.handleSelectHierarchyJob(hierarchyItemId, null)}
                        getAccessRight={this.props.getAccessRight}
                        getCustomNoAccessErrorStr={this.props.getCustomNoAccessErrorStr ?
                            selectedHierarchy => this.props.getCustomNoAccessErrorStr(selectedHierarchy) :
                            null
                        }
                        //if Clock device's hierarchy removed, we should open with global filter hierarchy.
                        openWithGlobalFilerWhenSelectedHierarchyIsInvalid={this.props.openWithGlobalFilerWhenSelectedHierarchyIsInvalid}
                    />
                </div>
                {AccountStore.getJobsEnabled() && !this.props.hideJob &&
                    <div style={{ flex: 1 }}>
                        <JobsChip
                            maxWidth={this.props.jobChipMaxWidth}
                            disabled={this.props.readonly || this.props.readonlyJob}
                            label={this.props.jobChipLabel}
                            filterHierarchyId={this.state.hierarchyItemId}
                            selectedJobs={this.state.job ? [this.state.job] : []}
                            restrictHierarchy
                            error={this.props.errorJobText}
                            handleSave={jobs => {
                                const job = jobs.length ? jobs[0] : null
                                this.handleSelectHierarchyJob(this.state.hierarchyItemId, job)
                            }}
                        />
                    </div>
                }
            </div >
        )
    }
}